import { cn } from '@/utils/cn';

export const CartIcon = ({ className }: { className?: string }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={cn('shrink-0', className)}
    aria-hidden
  >
    <g clipPath="url(#offers-pane-cart-clip)">
      <path
        d="M5.33341 14.6663C5.7016 14.6663 6.00008 14.3679 6.00008 13.9997C6.00008 13.6315 5.7016 13.333 5.33341 13.333C4.96522 13.333 4.66675 13.6315 4.66675 13.9997C4.66675 14.3679 4.96522 14.6663 5.33341 14.6663Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.6667 14.6663C13.0349 14.6663 13.3333 14.3679 13.3333 13.9997C13.3333 13.6315 13.0349 13.333 12.6667 13.333C12.2985 13.333 12 13.6315 12 13.9997C12 14.3679 12.2985 14.6663 12.6667 14.6663Z"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.3667 1.36621H2.70003L4.47337 9.64621C4.53842 9.94945 4.70715 10.2205 4.95051 10.4128C5.19387 10.605 5.49664 10.7064 5.8067 10.6995H12.3267C12.6301 10.6991 12.9244 10.5951 13.1607 10.4048C13.3971 10.2145 13.5615 9.94923 13.6267 9.65288L14.7267 4.69954H3.41337"
        stroke="currentColor"
        strokeWidth="1.33333"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="offers-pane-cart-clip">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
